module.exports = __webpack_public_path__ + "img/Dragonlab_FlowWatch.ab58a56e.svg";